export enum Assets {
    FOREST,
    CAT_WHITE,
    CAT_ORANGE,
    CAT_BLACK,
}

export const AssetLocation: { [key: number]: string } = {
    [Assets.FOREST]: process.env.PUBLIC_URL + "/models/forest.glb",
    [Assets.CAT_WHITE]: process.env.PUBLIC_URL + "/models/cat_white.glb",
    [Assets.CAT_ORANGE]: process.env.PUBLIC_URL + "/models/cat_orange.glb",
    [Assets.CAT_BLACK]: process.env.PUBLIC_URL + "/models/cat_black.glb",
};

export const AssetAnimations: { [key: number]: { [index: number]: string } } = {
    [Assets.CAT_WHITE]: {
        0: "Cat_Walk",
        1: "Idle",
        2: "Cat_Sit",
        3: "Cat_Run",
        4: "Cat_Death",
        5: "Cat_Sleep",
        6: "Cat_StandUp",
        7: "Cat_Attack",
    },
    [Assets.CAT_ORANGE]: {
        0: "Cat_Walk",
        1: "Idle",
        2: "Cat_Sit",
        3: "Cat_Run",
        4: "Cat_Death",
        5: "Cat_Sleep",
        6: "Cat_StandUp",
        7: "Cat_Attack",
    },
    [Assets.CAT_BLACK]: {
        0: "Cat_Walk",
        1: "Idle",
        2: "Cat_Sit",
        3: "Cat_Run",
        4: "Cat_Death",
        5: "Cat_Sleep",
        6: "Cat_StandUp",
        7: "Cat_Attack",
    },
};
